export default "__VITE_ASSET__DlU1n6IJ__"